import { Button, Carousel, CarouselContent, Container, Text } from '@doist/marketist'

import { useTranslation } from 'next-i18next'
import { Customer } from 'types/contentful'

import css from './UserStoryBox.module.css'

type UserStoryBoxProps = {
    customer: Customer
}

function UserStoryBox({ customer }: UserStoryBoxProps) {
    const { t } = useTranslation('common')
    return (
        <Container tag="section" width="base" className={css.userStoryBox}>
            <div className={css.content}>
                <img src={customer.logo.url} alt={customer.logo.alt} />
                <Text tag="h2" size="major-base">
                    {customer.title}
                </Text>
                <Button
                    target="_blank"
                    href={customer.blogLink.url}
                    variant="tertiary"
                    endIcon="ChevronRight"
                >
                    {customer.blogLink.text}
                </Button>
            </div>
            <div className={css.carousel}>
                <Carousel
                    id={customer.id}
                    nextButtonLabel={t('next', { ns: 'common' })}
                    previousButtonLabel={t('previous', { ns: 'common' })}
                >
                    {customer.carouselImages.map((image) => (
                        <CarouselContent
                            key={image.title}
                            image={<img src={image.url} alt={image.title} />}
                            caption={
                                <Text tag="p" size="body-sm">
                                    {image.caption}
                                </Text>
                            }
                        />
                    ))}
                </Carousel>
            </div>
        </Container>
    )
}

export { UserStoryBox }
